/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { useTheme } from 'styled-components';
import { Grid } from '@mui/material';
import { Line, Subtitulo, GraficoPizza, EnhancedTable } from '@monorepo-web/components-library';
import {
  sendAnalyticsData,
  useAppDispatch,
  useAppSelector,
  useFetchAPIs,
  getColumnsDadosAgrupadosCartExp,
  formatDadosAgrupados,
  formatRowsDadosAgrupadosCartExp,
  formatPieChartClasseData,
} from '@monorepo-web/logic-extrato';

import { ContainerInfo, BotaoAbrirModal, ContainerSubtitle } from './style';
import HeaderWrapper from '../../MainLayout/HeaderWrapper';

import ModalAviso from './ModalAviso';
import ModalInfo from './ModalInfo';
import { GraficoAlocacao, TabelaPosicaoConsolidada } from '@monorepo-web/templates';

const HEIGHT_BREAKPOINT = 650;

interface Props {
  dispatchPDF?: boolean;
  sendData?: any;
}

export default function CarteiraExplodida({ dispatchPDF, sendData }: Props) {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const [openModalAviso, setOpenModalAviso] = useState(false);
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [
    preferenceCustomizacao,
    dados_cart_explodida,
    aviso_carteira_explodida,
    obj_datas,
    isLoaded,
    loading,
    isLoadingMinimized,
    params,
  ] = useAppSelector((state) => [
    state.preference.preferenceStyle.customizacao,
    state.cartExp.dados_cart_explodida,
    state.cartExp.aviso_carteira_explodida,
    state.cartExp.obj_datas,
    state.cartExp.isLoaded,
    state.cartExp.loading,
    state.loadMinimized.isLoadingMinimized,
    state.preference.params,
  ]);

  useEffect(() => {
    if (!dispatchPDF) document.title = `${(window as any).env.REACT_APP_TABNAME} - Carteira Explodida`;
  }, []);

  useEffect(() => {
    if (isLoaded && !dispatchPDF) dispatch(sendAnalyticsData(location.href));
  }, [params, isLoaded]);

  useFetchAPIs(isLoaded, loading, dispatchPDF);

  useEffect(() => {
    if (!isLoaded && !loading && !dispatchPDF) {
      setOpenModalAviso(false); // sempre resetar o valor quando carregar os dados
      setOpenModalInfo(false);
    }
  }, [isLoaded]);

  // colunas da tabela
  const columnsDadosAgrupados = getColumnsDadosAgrupadosCartExp();
  const dadosAgrupados = isLoaded ? formatDadosAgrupados(dados_cart_explodida) : null;
  const rowsDadosAgrupados = isLoaded
    ? formatRowsDadosAgrupadosCartExp(dadosAgrupados, theme, dados_cart_explodida)
    : null;
  const pieChartClasseData = isLoaded ? formatPieChartClasseData(dadosAgrupados) : null;

  /** Define altura do gráfico: se for xl-> 500, caso contrário será 375 */
  const heightXL = 500;
  const heightLessXL = 375;
  const [chartHeight, setChartHeight] = useState(
    window.innerHeight > HEIGHT_BREAKPOINT ? heightXL : heightLessXL,
  );
  window.addEventListener('resize', () => {
    window.innerHeight > HEIGHT_BREAKPOINT ? setChartHeight(heightXL) : setChartHeight(heightLessXL);
  });

  const handleModalAvisoButton = () => {
    setOpenModalAviso(true);
  };
  const handleModalInfoButton = () => {
    setOpenModalInfo(true);
  };

  useEffect(() => {
    if (aviso_carteira_explodida && !aviso_carteira_explodida?.houve_explosao) {
      // mostrar aviso se não houve explosÃÂ£o(escolher datas disponíveis)
      setOpenModalAviso(true);
    }
  }, [aviso_carteira_explodida]);
  const avisoDataFim = aviso_carteira_explodida?.data_fim_AAAAmmDD_cart_explodida
    .split('-')
    .reverse()
    .join('/');

  useEffect(() => {
    if (dispatchPDF) {
      let data = {};
      if (aviso_carteira_explodida?.houve_explosao) {  // adiciona no PDF apenas se houver explosão
        data = {
          rowsDadosAgrupados,
          columnsDadosAgrupados,
          aviso_carteira_explodida,
          pieChartClasseData,
          obj_datas,
        };
      }
      sendData('CartExp', data);
    }
  }, []);

  if (dispatchPDF) {
    return <></>;
  }

  return (
    <>
      <Grid>
        <HeaderWrapper obj_datas={obj_datas} dataFim title="Carteira Explodida" data_fim_apenas />
        <ContainerInfo>
          {aviso_carteira_explodida?.explosao_xml_com_data_fim_alterada ? (
            <ContainerSubtitle>
              Carteira explodida em: {avisoDataFim} (data mais recente disponível)
              <BotaoAbrirModal onClick={handleModalInfoButton}>
                Mostrar informações da explosão
              </BotaoAbrirModal>
            </ContainerSubtitle>
          ) : isLoaded && !aviso_carteira_explodida?.houve_explosao ? (
            <ContainerSubtitle>
              Posição consolidada em: {avisoDataFim} (sem explosão)
            </ContainerSubtitle>
          ) : (
            <ContainerSubtitle>
              Carteira explodida em: {avisoDataFim}
              <BotaoAbrirModal onClick={handleModalInfoButton}>
                Mostrar informações da explosão
              </BotaoAbrirModal>
            </ContainerSubtitle>
          )}
          <BotaoAbrirModal onClick={handleModalAvisoButton} style={{ float: 'right' }}>
            Mostrar datas disponíveis para explosão
          </BotaoAbrirModal>
        </ContainerInfo>
        <Line />
      </Grid>
      <Grid container spacing={2} marginTop={'5px'} justifyContent="center" alignItems="center">
        <Grid
          item
          xs={12}
          lg={6}
          xl={5}
          container
          spacing={2}
          justifyContent="center"
          alignItems="center">
          <Grid item xs={12} sx={{ marginTop: 3 }}>
            <GraficoAlocacao
              data={pieChartClasseData}
              height={chartHeight}
              titulo='Alocação por Classe (exposição final)'
              layout='carteira_explodida'
            />
          </Grid>
        </Grid>
        <Grid item xs={12} lg={6} xl={7} container spacing={3} sx={{ marginTop: 0 }}>
          <Grid item xs={12}>
            <TabelaPosicaoConsolidada
              rows={rowsDadosAgrupados}
              layout='carteira_explodida'
              titulo=''
            />
          </Grid>
        </Grid>
      </Grid>
      <ModalAviso
        openModal={isLoaded && openModalAviso}
        setOpenModal={setOpenModalAviso}
        data={aviso_carteira_explodida?.datas_disponiveis ?? null}
        dataSelecionada={avisoDataFim}
        ativos_nao_existem_carteira={aviso_carteira_explodida?.ativos_nao_existem_carteira ?? null}
        houveExplosao={aviso_carteira_explodida?.houve_explosao ?? null}
      />
      <ModalInfo
        openModal={isLoaded && openModalInfo}
        setOpenModal={setOpenModalInfo}
        data={aviso_carteira_explodida?.infos_ativos_explodidos ?? null}
        dataSelecionada={avisoDataFim}
      />
    </>
  );
}
